<template>
      <a-col>
        <div class="provisioning_success_container">
            <a-button block class="green_bg step_btn" size="large" @click.prevent="enterMonitorPage">進入監控畫面</a-button>
        </div>
      </a-col>
</template>

<script>
    export default {
        name: 'ProvisioningResultButton',
        data() {
            return {

            }
        },
        methods: {
            enterMonitorPage() {
                const deviceUid = this.$route.query.data||'';
                console.log('進入監控畫面',deviceUid)

                // const deviceUid = this.$route.params.deviceUid||'';
                this.$router.push(`/individual/monitor?data=${encodeURIComponent(deviceUid)}`);
            }
        },
    }
</script>

<style lang="scss" scoped>
  .provisioning_success_container {
      margin-top: 12px;
  }
</style>